export var setLocalStoragePrefs = function (key, value) {
    if (key === undefined || value === undefined)
        return null;
    localStorage.setItem("engagebay-" + key, value);
};
export var getLocalStoragePrefs = function (key) {
    if (!key)
        return null;
    return localStorage.getItem("engagebay-" + key);
};
export var setSessionStoragePrefs = function (key, value) {
    if (key === undefined || value === undefined)
        return null;
    sessionStorage.setItem("engagebay-" + key, value);
};
export var removeSessionStoragePrefs = function (key) {
    try {
        sessionStorage.removeItem("engagebay-" + key);
    }
    catch (error) { }
};
export var getSessionStoragePrefs = function (key) {
    if (!key)
        return null;
    return sessionStorage.getItem("engagebay-" + key);
};
// export const deleteStoragePrefs: Function = (key: any) => {
//     localStorage.removeItem('engagebay-' + key);
// }
export var getCookie = function (key) {
    if (!key)
        return undefined;
    key = "engagebay-" + key;
    var ca = document.cookie.split(";");
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) === " ")
            c = c.substring(1, c.length);
        if (c.indexOf(key) === 0)
            return c.substring(key.length, c.length);
    }
    return undefined;
};
export var setCookie = function (key, value, timeInDays) {
    if (!key || !value)
        return undefined;
    var expires = "";
    if (timeInDays) {
        var date = new Date();
        date.setTime(date.getTime() + timeInDays * 24 * 60 * 60 * 1000);
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = "engagebay-" + key + "=" + value + expires + "; path=/";
};
export var deleteCookie = function (key) {
    if (!key)
        return;
    setCookie(key, "", -1);
};
